module.exports = __webpack_public_path__ + "static/media/faa-thumb.a546b22b.png";